// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"8fc71ebd","166":"c0fee7f5","253":"8f9e55db","345":"446d8281","916":"61e27b14","953":"e98601b5"}[chunkId] + ".css";
};